import React from 'react';
import ReactTooltip from 'react-tooltip';
import cx from 'classnames';

import { parseFilterAuthorsMarkdownToObject } from '@src/utils/parsers';
import { getShortPostDate, getReadingTime } from '@src/utils/calculations';

import { Button } from '@commons/button/Button';
import Image from '../image/Image';

import { Link } from '@commons/link/Link';

import readingTimeImg from '@images/blog/time.svg';
import dateIcon from '@images/blog/date-icon.svg';
import userIcon from '@images/blog/user.svg';
import categoriesIcon from '@images/blog/layers.svg';

import {
  container,
  cardDetailedInfo,
  cardDetailedInfoIcon,
  cardDetailedInfoText,
  cardImage,
  cardInfo,
  cardInfoHeader,
  cardTitle,
  detailsAuthor,
  detailsIcon,
  detailsName,
  detailsCategories,
  detailsCategoriesIcon,
  detailsCategoriesText,
  publishDateContainer,
  readTime,
  readMore,
} from './blog-post-card.module.scss';

const RenderCategories = ({ postCategories }) => {
  if (postCategories.length < 2) return postCategories[0]?.name;
  const categoriesTooltipStr = postCategories.map((cat) => cat.name).join(', ');
  return (
    <>
      <span data-tip={categoriesTooltipStr}>{postCategories[0].name}...</span>
      <ReactTooltip wrapper="span" />
    </>
  );
};

export const BlogPostCard = ({
  path,
  title,
  thumbnail,
  authors,
  words,
  postCategories,
  readingTime,
  classNames: { customContainer } = {},
}) => {
  const authorData = parseFilterAuthorsMarkdownToObject(authors);
  const timeToRead = getReadingTime(words);
  const publishDate = getShortPostDate(readingTime);

  return (
    <Link href={path} className={cx(container, customContainer)}>
      <div className={cardImage}>
        <Image image={thumbnail} alt={`Thumbnail of an article about ${title}`} objectFit="cover" />
      </div>
      <div className={cardInfo}>
        <div className={cardInfoHeader}>
          <div className={cardTitle} data-tip={title}>
            {title}
            {title.length > 67 && <ReactTooltip wrapper="span" />}
          </div>
          {timeToRead && (
            <div className={cardDetailedInfo}>
              <div className={readTime}>
                <div className={cardDetailedInfoIcon}>
                  <img loading="lazy" src={readingTimeImg} alt="Time to read" />
                </div>
                <p className={cardDetailedInfoText}>{timeToRead} reading</p>
              </div>
              <div className={publishDateContainer}>
                <div className={cardDetailedInfoIcon}>
                  <img loading="lazy" src={dateIcon} alt="Publish date" />
                </div>
                <p className={cardDetailedInfoText}>{publishDate}</p>
              </div>
            </div>
          )}
        </div>
        <div>
          <div className={detailsAuthor}>
            <div className={detailsIcon}>
              <img loading="lazy" src={userIcon} alt="" />
            </div>
            <p className={detailsName}>{authorData.name}</p>
          </div>
          <div className={detailsCategories}>
            <div className={detailsCategoriesIcon}>
              <img loading="lazy" src={categoriesIcon} alt="" />
            </div>
            <p className={detailsCategoriesText}>
              <RenderCategories postCategories={postCategories} />
            </p>
          </div>
        </div>
        <div className={readMore}>
          <Button label="Read more" href={path} rel="nofollow" />
        </div>
      </div>
    </Link>
  );
};
